import React from 'react'
import { TextInput } from '@tecuity/granite-ui/TextInput'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'

const MiscRecordDetailCardDrawerContent = ({ card, onLabelChange, onDeleteClick }) => {
  return (
    <div className="misc-record-detail-card-drawer-content">
      <TextInput
        label="Label"
        value={card.Label}
        onChange={(e) => onLabelChange(e.target.value)}
      />
      <ContextButton variant="danger" onClick={onDeleteClick}>
        Delete Card
      </ContextButton>
    </div>
  )
}

export default MiscRecordDetailCardDrawerContent
